const SENSITIVE_KEYS = ["email", "token", "password", "magic_link_token", "api_key"];

export function stripSensitiveQueryParams(url) {
  if (url == null) return url;

  try {
    const parsed = new URL(url);
    SENSITIVE_KEYS.forEach((key) => {
      if (parsed.searchParams.has(key)) {
        parsed.searchParams.set(key, "[FILTERED]");
      }
    });
    return parsed.toString();
  } catch {
    return url;
  }
}
